export const FRONT = true;
export const BACK = false;
export const TYPES_API = FRONT ? "/api/associations/types/" : "/associations/api/associations/types/";
export const LIEUX_API = FRONT ? "/api/associations/lieux/" : "/associations/api/associations/lieux/";
export const ASSOCIATIONS_API = FRONT ? "/api/associations/" : "/associations/api/associations/";

export const jours = [
  { j0: "Lundi" },
  { j1: "Mardi" },
  { j2: "Mercredi" },
  { j3: "Jeudi" },
  { j4: "Vendredi" },
  { j5: "Samedi" },
  { j6: "Dimanche" },
  { j7: "Variable" },
];

export const heures = [
  { id: 0, intitule: "--" },
  { id: 1, intitule: "0" },
  { id: 2, intitule: "1" },
  { id: 3, intitule: "2" },
  { id: 4, intitule: "3" },
  { id: 5, intitule: "4" },
  { id: 6, intitule: "5" },
  { id: 7, intitule: "6" },
  { id: 8, intitule: "7" },
  { id: 9, intitule: "8" },
  { id: 10, intitule: "9" },
  { id: 11, intitule: "10" },
  { id: 12, intitule: "11" },
  { id: 13, intitule: "12" },
  { id: 14, intitule: "13" },
  { id: 15, intitule: "14" },
  { id: 16, intitule: "15" },
  { id: 17, intitule: "16" },
  { id: 18, intitule: "17" },
  { id: 19, intitule: "18" },
  { id: 20, intitule: "19" },
  { id: 21, intitule: "20" },
  { id: 22, intitule: "21" },
  { id: 23, intitule: "22" },
  { id: 24, intitule: "23" },
];

export const minutes = [
  { id: 0, intitule: "--" },
  { id: 1, intitule: "00" },
  { id: 2, intitule: "15" },
  { id: 3, intitule: "30" },
  { id: 4, intitule: "45" },
];
